<template>
  <div class="editable-chart-title">
    <input
      class="editable-chart-title__input"
      type="text"
      :value="value"
      :placeholder="placeholder"
      :aria-label="placeholder"
      :title="hint"
      data-testid="editable-chart-title"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
// HCI-4741: an editable heading above an Analysis report chart.
//
// The chart itself shows no Highcharts title. This element replaces it. The
// user can rename the report at any time. The new name shows on screen and on
// every print, because it is a normal page element.
export default {
  name: "editable-chart-title",
  props: {
    // The current title. Use with v-model.
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Report title",
    },
    hint: {
      type: String,
      default: "Click to rename this report. The name shows when you print.",
    },
  },
};
</script>

<style scoped>
.editable-chart-title {
  display: flex;
  justify-content: center;
  padding: 6px 0 2px;
}

.editable-chart-title__input {
  width: 100%;
  max-width: 40em;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: #333;
  font-family: inherit;
  font-size: 18px !important;
  font-weight: bold;
  text-align: center;
  text-overflow: ellipsis;
}

.editable-chart-title__input:hover {
  border-color: #dcdfe6;
}

.editable-chart-title__input:focus {
  border-color: #20a0ff;
  outline: none;
}

.editable-chart-title__input::placeholder {
  color: #b0b3b8;
  font-weight: normal;
}

@media print {
  .editable-chart-title__input {
    /* Print the text only. Hide the input frame. */
    border-color: transparent;
    color: #333;
  }

  .editable-chart-title__input::placeholder {
    color: transparent;
  }
}
</style>
